export default __webpack_public_path__ + "static/media/iconLocations.1f29c429.svg";